export class CambioNombreBoleta {
    _id_cambio_nombre_boleta: Number;
    rut: String;
    nombre: String;
    telefono: String;
    email: String;
    numero_cliente: String;
    nombre_boleta: String;
    archivo_cedula_identidad: String;
    archivo_cedula_identidad_reverso: String;
    acepto_condiciones: Boolean;
    acepto_newsletters: Boolean;
    acepto_privacidad: Boolean;
    acepto_suscripcion: Boolean;
    token: String;
    ip: String;
 }